import useTranslation from 'next-translate/useTranslation'

function BenetitItem({ copy }: BenetitItemProps) {
  const { t } = useTranslation('wellBeing')

  return (
    <div className="flex space-x-2">
      <div className="w-2 h-2 mt-4 bg-white rounded-full"></div>
      <p className="w-full mt-3 text-xs text-white md:text-sm">
        {t(`${copy}`)}
      </p>
    </div>
  )
}

interface BenetitItemProps {
  copy: string
}

export default BenetitItem
